import { AlertList } from 'components/WeatherAlerts/AlertList';
import WidgetLoadingAnimation from 'components/Widgets/WidgetLoadingAnimation';
import WidgetTimeUpdate from 'components/Widgets/WidgetTimeUpdate';
import { usePerms } from 'contexts/PermsContext';
import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useGetAllActiveAlertsQuery } from 'services/alerts/alerts.api';

export default function Alerts({ dimensions, sidebarOpen }) {
  const { data: allActiveAlerts = [] } = useGetAllActiveAlertsQuery();
  const [alertsList, setAlertsList] = useState([]);
  const [fetching, setFetching] = useState(true);
  const perms = usePerms();
  const navigate = useNavigate();
  const ROUTE = 'getAllActiveAlerts';

  useEffect(() => {
    if (allActiveAlerts?.length) {
      setAlertsList(allActiveAlerts);
      setFetching(false);
    }
  }, [allActiveAlerts]);

  useEffect(() => {
    (async () => {
      if (!(await perms.validatePermissions(['ViewAlerts']))) {
        navigate('/404');
        return;
      }
    })();
  }, [navigate, perms]);

  if (fetching) {
    return (
      <Container fluid className="mt-3">
        <WidgetLoadingAnimation widgetName={'ActiveAlerts'} dimensions={dimensions} />
      </Container>
    );
  }

  if (perms.testPermission([8, 9, 10, 11, 12, 13], ['WeatherAlerts']))
    return (
      <Container fluid className="py-3">
        {dimensions ? (
          <div>
            {fetching ? (
              <p>fetching...</p>
            ) : (
              <AlertList
                widget
                dimensions={dimensions}
                title={'Active Weather Alerts'}
                alertsList={alertsList}
                setAlertsList={setAlertsList}
                sidebarOpen={sidebarOpen}
                ROUTE={ROUTE}
              />
            )}
          </div>
        ) : (
          <div style={{ height: 'calc(100% - 20px)' }}>
            <WidgetTimeUpdate route={ROUTE} realtime dataUpdateOnly addMargin />
            <AlertList
              title={'Active Weather Alerts'}
              alertsList={alertsList}
              setAlertsList={setAlertsList}
              sidebarOpen={sidebarOpen}
              ROUTE={ROUTE}
            />
          </div>
        )}
      </Container>
    );
}
